import React from 'react';
import styles from './AuthenticationInput.module.css'

interface IProps {
    type: string,
    placeholder?: string
    onChange?: (e: any) => void
}

const AuthenticationInput = (props: IProps) => {
    return (
        <input onChange={props.onChange} type={props.type} placeholder={props.placeholder} className={styles.authenticationInput}/>
    );
};

export default AuthenticationInput;